var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictorSlideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1 16.4999C1 24.6001 7.56649 31.1666 15.6667 31.1666C23.7668 31.1666 30.3333 24.6001 30.3333 16.4999C30.3333 8.39974 23.7668 1.83325 15.6667 1.83325C7.56649 1.83325 1 8.39974 1 16.4999Z",
    stroke: "#49A942",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M17.5858 10.8333L12.2929 16.1261C11.9024 16.5167 11.9024 17.1498 12.2929 17.5404L17.5858 22.8333",
    stroke: "#49A942",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictorSlideLeft);
export default __webpack_public_path__ + "static/media/predictor-slide-left.fde1f1f7f2a91036d36e3017ef5711b9.svg";
export { ForwardRef as ReactComponent };